import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/clubs', config)
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/clubs/' + id)
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/student/clubs', data)
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/student/clubs/' + id, formData)
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/student/clubs/' + id)
}

const getMyClubs = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/students/me')
}

const getMyClubVoteList = async (studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/votes/club-vote-list/'+studentClubId)
}

const voteAnswer = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/student/club/vote/answer', formData)
}

const getMyClubVoteAnswer = async (studentClubVoteId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/vote/get-vote-answer/'+studentClubVoteId)
}

const makePresidentApplication = async (studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/president/application/users/make-application/'+studentClubId)
}

const cancelPresidentApplication = async (studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/president/application/users/remove-application/'+studentClubId)
}

const leaveTheClub = async (studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/students/leave-club/'+studentClubId)
}

const getAllPresident = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/applications', config);
}

const getPresident = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/applications/' + id);
}

const updatePresident = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/student/club/president/applications/' + id, formData);
}

const delPresident = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/student/club/president/applications/' + id);
}

const storePresident = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/club/president/applications', data);
}

const getAllPresidentUsers = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/application/users', config);
}

const getPresidentUsers = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/application/users/' + id);
}

const updatePresidentUsers = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/student/club/president/application/users/' + id, formData);
}

const delPresidentUsers = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/student/club/president/application/users/' + id);
}

const storePresidentUsers = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/club/president/application/users', data);
}

const createAVote = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/applications/publish-vote/' + id);
}

const clubList = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/clubs/list', config)
}

const joinClub = async (studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/club/students/join-club/'+studentClubId)
}

const downloadAsExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/clubs/excel-export', {...config, responseType:'arraybuffer'});
}

const downloadAsExcelPresidentClubApplication = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/president/applications/excel-export', {...config, responseType:'arraybuffer'});
}

const makePayment = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/club/student/make-payment', data);
}

const joinClubDateControl = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/students/join-club-date-control');
}

const presidentsClubMemberList = async (config, studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/students/president-student-list/'+studentClubId, config)
}

const downloadAsExcelPresidentStudentList = async (config, studentClubId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/students/president-student-list/excel-export/'+studentClubId, {...config, responseType:'arraybuffer'});
}

export default {
    getAll,
    get,
    update,
    store,
    del,
    getAllPresident,
    getPresident,
    delPresident,
    storePresident,
    updatePresident,
    getAllPresidentUsers,
    getPresidentUsers,
    delPresidentUsers,
    storePresidentUsers,
    updatePresidentUsers,
    createAVote,
    getMyClubs,
    getMyClubVoteList,
    voteAnswer,
    getMyClubVoteAnswer,
    makePresidentApplication,
    cancelPresidentApplication,
    leaveTheClub,
    clubList,
    joinClub,
    downloadAsExcel,
    downloadAsExcelPresidentClubApplication,
    makePayment,
    joinClubDateControl,
    presidentsClubMemberList,
    downloadAsExcelPresidentStudentList
}
